import { immutableTags } from 'modules/ActivityTags/types';

export const isTagImmutable = (tagType) => immutableTags.includes(tagType)
